
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const KitchenRemodelPage = lazy(() => import('../pages/kitchen-remodel/page'));
const BathroomRemodelPage = lazy(() => import('../pages/bathroom-remodel/page'));
const PaintingPage = lazy(() => import('../pages/painting/page'));
const HomeRemodelingPage = lazy(() => import('../pages/home-remodeling/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const GalleryPage = lazy(() => import('../pages/gallery/page'));
const TestimonialsPage = lazy(() => import('../pages/testimonials/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/kitchen-remodel',
    element: <KitchenRemodelPage />,
  },
  {
    path: '/bathroom-remodel',
    element: <BathroomRemodelPage />,
  },
  {
    path: '/painting',
    element: <PaintingPage />,
  },
  {
    path: '/home-remodeling',
    element: <HomeRemodelingPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/gallery',
    element: <GalleryPage />,
  },
  {
    path: '/testimonials',
    element: <TestimonialsPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
